export default __webpack_public_path__ + "static/media/ic_contracts.b09981f8.png";